import * as USERGROUPS from './userGroups.constants';
import { UserGroups } from '../../models';

/** LOAD */
export function loadUserGroups() {
    return { type: USERGROUPS.USER_GROUPS_LOAD };
}

export function loadUserGroupsSuccess(data: UserGroups[]) {
    return { type: USERGROUPS.USER_GROUPS_LOAD_SUCCESS, payload: data };
}

export function loadUserGroupsError(error: any) {
    return { type: USERGROUPS.USER_GROUPS_LOAD_ERROR, payload: error };
}


/** ADD */
export function addUserGroups(targetUserGroups: UserGroups[]) {
    return { type: USERGROUPS.USER_GROUPS_ADD, payload: targetUserGroups };
}

export function addUserGroupsSuccess(targetUserGroups: UserGroups[]) {
    return { type: USERGROUPS.USER_GROUPS_ADD_SUCCESS, payload: targetUserGroups };
}

export function addUserGroupsError(error: any) {
    return { type: USERGROUPS.USER_GROUPS_ADD_ERROR, payload: error };
}


/** UPDATE */
export function updateUserGroups(targetUserGroups: UserGroups) {
    return { type: USERGROUPS.USER_GROUPS_UPDATE, payload: targetUserGroups };
}

export function updateUserGroupsSuccess(targetUserGroup: UserGroups) {
    return { type: USERGROUPS.USER_GROUPS_UPDATE_SUCCESS, payload: targetUserGroup };
}

export function updateUserGroupsError(error: any) {
    return { type: USERGROUPS.USER_GROUPS_UPDATE_ERROR, payload: error };
}


/** DELETE */
export function deleteUserGroups(guid: string) {
    return { type: USERGROUPS.USER_GROUPS_DELETE, payload: guid };
}

export function deleteUserGroupsSuccess(userGroup: UserGroups) {
    return { type: USERGROUPS.USER_GROUPS_DELETE_SUCCESS, payload: userGroup };
}

export function deleteUserGroupsError(error: any) {
    return { type: USERGROUPS.USER_GROUPS_DELETE_ERROR, payload: error };
}